import React from "react"
import { Button } from "react-bootstrap"
import './404.scss'

interface Props404 {
	lang: String
}

const P404: React.FC<Props404> =  (props: Props404) => {
	const lang = props.lang
	return(
	<div className="p404 d-flex justify-content-center flex-column">
		<h1>{lang==='nl' ? "Niet gevonden" : "Not found"}</h1>
		<p>{lang==='nl' ? "De gezochte URL was niet gevonden op de server. Als je de URL handmatig hebt ingevult, check de spelling en probeer het nog eens." : "The requested URL was not found on the server. If you entered the URL manually please check your spelling and try again."}</p>
		<Button className="homeBtn" variant="outline-dark" href="/">Home</Button>
	</div>
	)
}

export default P404